// src/pages/lead-automation/components/GoogleConnectBanner.jsx
import React from 'react';
import { Wifi, WifiOff, Loader, ExternalLink } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './GoogleConnectBanner.module.css';

const GoogleConnectBanner = ({ status, onConnect, onDisconnect, connectLoading, disconnectLoading }) => {
  const { t } = useLocalization();
  const la = (key) => t(`leadAutomation.${key}`);

  if (status === null) return null;

  if (status.connected) {
    return (
      <div className={`${styles.banner} ${styles.connected}`}>
        <div className={styles.info}>
          <Wifi size={18} className={styles.icon} />
          <div>
            <span className={styles.label}>{la('googleConnected')}</span>
            {status.googleEmail && (
              <span className={styles.email}>{status.googleEmail}</span>
            )}
          </div>
        </div>
        <button
          className={styles.disconnectBtn}
          onClick={onDisconnect}
          disabled={disconnectLoading}
        >
          {disconnectLoading ? (
            <><Loader size={14} className={styles.spin} /> {la('googleDisconnecting')}</>
          ) : (
            la('disconnectGoogle')
          )}
        </button>
      </div>
    );
  }

  return (
    <div className={`${styles.banner} ${styles.disconnected}`}>
      <div className={styles.info}>
        <WifiOff size={18} className={styles.icon} />
        <div>
          <span className={styles.label}>{la('googleNotConnected')}</span>
          <span className={styles.description}>{la('googleNotConnectedDescription')}</span>
        </div>
      </div>
      <button
        className={styles.connectBtn}
        onClick={onConnect}
        disabled={connectLoading}
      >
        {connectLoading ? (
          <><Loader size={14} className={styles.spin} /> {la('googleConnecting')}</>
        ) : (
          <><ExternalLink size={14} /> {la('connectGoogle')}</>
        )}
      </button>
    </div>
  );
};

export default GoogleConnectBanner;
